console.log('including online-participant...');

import './online-participant/online-exam-ng';

window.loadItemCommentModal = function(exam_id, item_index, title, onload){
    if(window.cfg.isPreview) return;

	// take the title from page
	$('#oleCommentItemModalTitle').html('');
	$('#oleCommentItemModalTitle').append(title);

	var request = {
		exam_id: exam_id,
		item: item_index,
		rt: new Date().getTime(),
		_token: csrf_token
	};

	$.ajax({
		url: 'question/comment',
		data: request,
		// dataType: 'json',
		success: function(data){
			$('#oleCommentItemModalText').val(data['comment']);
            if(onload) onload();
			$('#oleCommentItemModalText').focus();
		},
		error: function(data){
			console.log("error",data);
			$('#oleCommentItemModalText').focus();
		},
		type: 'GET'
	});
}

window.saveItemCommentModal = function(exam_id, item_index, comment_text, postSave){
	var request = {
		exam_id: exam_id,
		item: item_index,
		comment: comment_text,
		schedule_only: 0,
		rt: new Date().getTime(),
		_token: csrf_token
	};

	$.ajax({
		url: 'question/comment',
		data: request,
		// dataType: 'json',
		success: function(data){
			$('#oleCommentItemModal').modal('hide');
			$('#oleCommentItemModalText').val('');

			window.location.reload();
		},
		error: function(data){
			console.log("error", data);
		},
		type: 'PUT'
	});
}

window.showOleCommmentItemModal = function(){
	// $('#oleCommentItemModalSaveBtn').on('click', saveItemCommentModal);
	// $('#oleCommentItemModal').on('show.bs.modal', loadItemCommentModal)
}
window.loadAndShowItemCommentModal = function(exam_id, item_index){


    $.ajax({
        url:'mct-get-item.php',
        dataType:'json',
        data:{
            item:item_index,
            is_comment:1,
        },
        success: function(data, status, request){
            var question_index = parseInt(data.item.id) + 1;
            var title = 'Comment question ' + question_index;
            $('#oleCommentItemModalSaveBtn').on('click', function(comment_text){
                var comment_text = $('#oleCommentItemModalText').val();
                window.saveItemCommentModal(exam_id, item_index, comment_text);

            });
            $('#oleCommentItemModal').on('hidden.bs.modal', function(){
                $('#oleCommentItemModal .modal-body').prepend($('#oleCommentItemModalForm'));
                $('#oleCommentItemModal .modal-body').children().not("#oleCommentItemModalForm, #oleCommentItemModalForm *").remove();
                $('#oleCommentItemModal .modal-title').empty();

                // unregister these new events on close
                $('#oleCommentItemModal').off('hidden.bs.modal')
                $('#oleCommentItemModalSaveBtn').off('click')
            })

            window.loadItemCommentModal(exam_id, item_index, title, function(){

                $('#oleCommentItemModal modal-dialog').removeClass('modal-lg');
                $('#oleCommentItemModal modal-dialog').addClass('modal-xl');

                let main_body = $('#oleCommentItemModal .modal-body');

                main_body.wrapInner('<div class="col-4"></div>');
                let q_col = $('<div class="col-8"></div>');
                $('#oleCommentItemModalText').attr('rows', 10);
                q_col.appendTo(main_body);
                window.renderQuestionForComment(q_col,data,item_index);
                main_body.wrapInner('<div class="row"></div>');

            });

            $('#oleCommentItemModal').modal('show');
        }
    })
}

window.renderQuestionForComment = function(element, item_info, item_index){
    $(element).append($(`
    <div id="mainPane">
        <dl id="oleItem" class="overflow-hidden">
            <dt id="oleItemStem"></dt>
            <dd id="oleItemAnswers"></dd>
        </dl>
    </div>`))

    // prepare elements
    window.OLE.init(cfg);
    var itemStemEl = document.getElementById('oleItemStem');
    var itemAnswersEl = document.getElementById('oleItemAnswers');
    window.OLE.renderQuestionForComment(item_info, item_index, itemStemEl, itemAnswersEl);
    $("#oleItem").css('visibility', 'visible');
}
